<template>
    <div
        id="app"
        @contextmenu="contextMenuHandler"
    >
        <loading-animation
            class="loading"
            v-if="loading"
        ></loading-animation>
        <router-view v-else></router-view>
        <cookie-consent
            id="cookie-consent"
            class="text-center"
            message="RikordaEventi utilizza i cookie propri e di terze parti per garantire una migliore esperienza sul sito
                    e per la profilazione delle scelte dell'utente. Continuando a navigare acconsenti al loro utilizzo."
            linkLabel="Maggiori informazioni"
            :href="$router.resolve({ name: 'cookie'}).href"
            buttonLabel="Accetta le condizioni"
        >
            <template slot="button">
                <div>
                    <button class="btn btn-info">{{ $t('Accetto le condizioni') }}</button>
                </div>
            </template>
        </cookie-consent>
        <b-alert
            id="update-alert"
            class="update-alert"
            v-if="versionChanged"
            show
            variant="warning"
        >
            <div class="m-0">
                <div class="m-0 text-center">
                    <span class="info mr-3">
                        {{ $t("E' disponibile una nuova versione del sito, clicca sul pulsante per ricaricare la pagina.") }}
                    </span>
                    <button
                        class="pulsante-crea-gallery btn btn-primary btn-rikorda1"
                        @click="reloadApp"
                    >{{ $t('Ricarica') }}</button>
                </div>
            </div>
        </b-alert>
    </div>
</template>

<script>
import LoadingAnimation from "./components/LoadingAnimation";
import CookieConsent from "vue-cookieconsent-component";
import axios from "axios";

export default {
    name: "RikordaEventiApp",

    components: {
        LoadingAnimation,
        CookieConsent
    },

    data() {
        return {
            localVersion: process.env.VERSION,
            remoteVersion: null,
            versionChanged: false,
            loading: true
        };
    },

    beforeCreate() {
        console.debug("BEFORE CREATE");
        this.$store
            .dispatch("GET_SHOP_DATA")
            .then((result) => {
                console.debug("GET_SHOP_DATA", result);
                var shopData = this.$store.getters.shopData;
                var staticPageRoutes = [];
                if (
                    shopData &&
                    !shopData.isGlobalSite &&
                    this.$route.meta.staticWebPage &&
                    location.hostname != "localhost"
                ) {
                    this.$router.push({ name: "eventcode" });
                }
            })
            .catch((error) => {
                console.error("GET_SHOP_DATA", error);
            })
            .finally(() => {
                var that = this;
                setTimeout(function () {
                    that.loading = false;
                }, 500);
            });

        if (this.$store.getters.tokenBE) {
            this.$store
                .dispatch("GET_USER_DATA_BE")
                .then((result) => {
                    console.debug("GET_USER_DATA_BE", result);
                })
                .catch((error) => {
                    console.error("GET_USER_DATA_BE", error);
                });
        }
    },

    beforeMount() {
        var shopData = this.$store.getters.shopData;
        console.debug("BEFORE MOUNT", shopData);
    },

    mounted() {
        var shopData = this.$store.getters.shopData;
        console.debug("MOUNTED", shopData);
        this.initVersionCheck("/config.json");
    },

    methods: {
        initVersionCheck(url, frequency = 1000 * 60 * 2) {
            // fa subito un check, poi gli altri li fa ad intervalli con frequenza
            this.checkVersion(url);
            setInterval(() => {
                this.checkVersion(url);
            }, frequency);
        },

        async checkVersion(url) {
            try {
                if (location.hostname != "localhost") {
                    const fileResponse = await axios
                        .create({
                            baseURL: location.protocol + "//" + location.host,
                            headers: {
                                "Content-type": "application/json"
                            }
                        })
                        .get(url + "?t=" + new Date().getTime());
                    this.remoteVersion = fileResponse.data.version;
                    this.versionChanged = this.hasVersionChanged(
                        this.localVersion,
                        this.remoteVersion
                    );
                }
            } catch (error) {
                console.error(error);
                if (!error.response) {
                    this.errorStatus = "Error: Network Error";
                } else {
                    this.errorStatus = error.response.data.message;
                }
            }
        },

        hasVersionChanged(currentVersion, newVersion) {
            return newVersion !== null ? currentVersion !== newVersion : false;
        },

        reloadApp() {
            this.currentVersion = this.newVersion;
            window.location.reload();
        },

        contextMenuHandler(e) {
            if (process.env.NODE_ENV === "production") {
                // disabilita contextmenu in produzione
                e.preventDefault();
            }
        }
    }
};
</script>

<style scoped>
.loading {
    position: absolute;
    top: 50%;
}

#update-alert {
    position: fixed;
    z-index: 9999;
    bottom: 0;
    width: 100vw;
    margin-bottom: 0;
    background-color: var(--tiffany-sbiadito);
}

#update-alert .info {
    color: var(--blu-rikorda);
}

.cookie-consent {
    background: rgba(119, 119, 119, 0.85) none repeat scroll 0 0;
    color: white;
    position: fixed;
    z-index: 10000;
    bottom: 0;
    width: 100vw;
    margin-bottom: 0;
    padding-bottom: 0.3rem;
    min-height: auto !important;
}

.cookie-consent button {
    background-color: white;
    border-color: white;
    color: #333;
    font-size: 0.8rem;
}

.cookie-consent /deep/ .cookie-consent-message {
    font-size: 0.8rem !important;
}

.cookie-consent /deep/ .cookie-consent-link {
    color: white;
    text-decoration: underline;
}
</style>
